var _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBannerIllustration(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1245,
    height: 754,
    viewBox: "0 0 1245 754",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M473.215 0C418.601 44.7893 375.245 98.3296 366.887 157.141C352.302 259.77 376.277 293.509 394.95 319.788C407.131 336.93 417.057 350.898 412.55 378.745C408.099 406.241 359.057 439.363 303.045 477.192C215.376 536.401 110.634 607.14 133.078 685.888C139.678 709.047 156.725 731.966 180.496 754H1245V0L473.215 0Z",
    fill: "url(#paint0_linear_8_1167)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M439.083 155.404C457.172 230.145 474.907 303.421 449.5 334C407.186 384.927 399.366 388.178 358.2 405.294C344.4 411.031 326.852 418.327 303 429.5C208 474 96.2941 556.828 133.078 685.888C139.678 709.047 156.725 731.966 180.496 754H1245V0H416.074C411.254 40.4197 425.272 98.3387 439.083 155.404Z",
    fill: "url(#paint1_linear_8_1167)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100.591 754H1245V0L552.288 0C531.225 22.2819 516.616 45.6615 510.5 69.9999C481.433 185.665 498.035 248.517 511.004 297.613C519.646 330.331 526.675 356.94 517.5 389C508.405 420.779 414.716 449.659 309.534 482.083C149.372 531.455 -37.4387 589.042 7.18562 677.584C20.2749 703.555 53.8055 729.263 100.591 754Z",
    fill: "url(#paint2_linear_8_1167)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8_1167",
    x1: 1245,
    y1: -0.0000657307,
    x2: 123.276,
    y2: 657.418,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6CC788"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6CC788",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_8_1167",
    x1: 1245,
    y1: -0.0000657307,
    x2: 121.265,
    y2: 661.024,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6CC788"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6CC788",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_8_1167",
    x1: 2242.42,
    y1: -102,
    x2: 782.057,
    y2: 1412.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6CC788"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6CC788",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBannerIllustration);
export default __webpack_public_path__ + "static/media/banner-illustration.94b472880798ab1e3267fc41b7c2b4ca.svg";
export { ForwardRef as ReactComponent };